import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import { router } from './router';
import vuetify from './plugins/vuetify';
import '@/scss/style.scss';
import Vue3Marquee from 'vue3-marquee';
import VueApexCharts from 'vue3-apexcharts';
import * as Sentry from '@sentry/vue';

// google-fonts
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/700.css';

import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';

import '@fontsource/poppins/400.css';
import '@fontsource/poppins/500.css';
import '@fontsource/poppins/600.css';
import '@fontsource/poppins/700.css';

import '@fontsource/public-sans/400.css';
import '@fontsource/public-sans/500.css';
import '@fontsource/public-sans/600.css';
import '@fontsource/public-sans/700.css';

//Mock Api data
import './_mockApis';
import { fakeBackend } from '@/utils/helpers/fake-backend';
// maska
import { vMaska } from 'maska';
// safeHtml
import { safeHtml } from '@/directives/safeHtml';
// print
import print from 'vue3-print-nb';
// Table
// @ts-ignore
import Vue3EasyDataTable from 'vue3-easy-data-table';
//i18
import { i18n } from '@/plugins/i18n';
import NativeScrollbar from '@/components/shared/NativeScrollbar.vue';

const isSentryEnabled = import.meta.env.VITE_ENABLE_SENTRY === 'true';
const app = createApp(App);

if (isSentryEnabled) {
  Sentry.init({
    app,
    dsn: import.meta.env.VITE_SENTRY_DSN,
    sendDefaultPii: true,
  });
}

fakeBackend();

const pinia = createPinia();
app.use(pinia);

app.use(i18n);
app.use(vuetify);
app.use(router);
app.component('EasyDataTable', Vue3EasyDataTable);
app.component('PerfectScrollbar', NativeScrollbar);
app.use(print);
app.use(Vue3Marquee);
app.directive('maska', vMaska);
app.directive('safe-html', safeHtml);
app.use(VueApexCharts);

app.mount('#app');
